export const MAIL_TEMPLATE = {
  RECIPIENT: import.meta.env.VITE_ONBOARDING_EMAIL,
  SUBJECT: 'Request API Key Production',
  BODY: 'Hello OY!%0D%0A%0D%0AI want to request API key for my account%0D%0A%0D%0AThanks',
};
